<template>
	<div class="p-panel" v-if="channel"  :class="{ 'p-panel--loading': loading, 'p-panel--devmode': devmode}">
		<router-view class="view"></router-view>
    </div>
</template>

<script>

export default {
	name: 'p-panel',
	computed: {
		devmode(){
			return this.$store.getters.devmode;
		},
		channel(){
			return this.$store.getters.channel;
		},
		loading(){
			return this.$store.getters.loading;
		}
	}
}

</script>


<style lang="scss">
	.p-panel {
		&--loading {
			pointer-event: none;
			opacity: .7;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/p-panel.vue